import React from 'react';

import { connect } from 'react-redux';
import partnerActions from '../../redux/futures/partner/actions';
import _ from 'lodash';
import appConst from '../../config/const';
import Pagination from "react-js-pagination";
import baseHelper from '../../helpers/BaseHelper';

import CustomDatePicker from "../../components/DatePicker/CustomDatePicker";
import LoadingTable from '../../components/LoadingTable';


import * as types from '../../redux/futures/partner/types';

class Credit extends React.Component {

    constructor(props) {
        super(props);

        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.state = {
            activePage: 1,
            fromDate: firstDay,
            toDate: new Date(),
            searchEmail: '',
            searchCode: '',
            selectedLimit: appConst.PAGINATION.LIMIT_OPTIONS[1].value,
            searchType: {
                name: appConst.CREDIT_LOG_TYPE.ALL.name,
                value: appConst.CREDIT_LOG_TYPE.ALL.value,
                selected: appConst.CREDIT_LOG_TYPE.ALL.value,
            },
            userInfo: false,
            credits: [],
            sortby: appConst.SORT_BY.DESCENDING
        }

        this.muteActions = [];
    }

    componentDidMount() {
        this.getList();
    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.action && !_.includes(this.muteActions, nextProps.action) && nextProps.action === types.LIST_CREDIT_LOGS) {
            if (nextProps.status) {
                this.setState({ creditlogs: nextProps.creditlogs, userInfo: nextProps.userInfo });
                // window.LadiUI.toastr('success', '', nextProps.message);
            } else {
                window.LadiUI.toastr('error', '', nextProps.message);
            }

            // this.getList();
        }
    }

    changeFromdate = (date) => {

        this.setState({
            fromDate: date
        }, () => {
            this.getList();
        });

    }

    changeTodate = (date) => {
        this.setState({
            toDate: date
        }, () => {
            this.getList();
        });

    }


    /**
     * list store
     */
    getList = (resetActivePageFlag = true) => {


        const { searchEmail, selectedLimit, searchCode, searchType } = this.state;

        let { activePage } = this.state;
        if (resetActivePageFlag) {
            activePage = 1;

            this.setState({
                activePage: 1,
            });
        }


        let { fromDate, toDate } = this.state;
        fromDate.setHours(0, 0, 0, 0);

        toDate.setHours(23, 59, 59, 999);
        const data = {
            "limit": selectedLimit,
            "offset": (activePage - 1) * selectedLimit,
            "email": searchEmail,
            "code": searchCode,
            "from_date": fromDate,
            "to_date": toDate,
            "type": searchType.selected
        };

        this.props.list(data);
    }

    /*******************************SEARCH***************************/
    onChangeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    /**
     * Tim kiem theo name
     */
    onKeyDownInput = (event) => {
        if (event.key === 'Enter') {
            this.getList();
        }
    }

    onChangeSearchType = (option) => {
        this.setState({
            searchType: { ...this.state.searchType, selected: option.value },
        }, () => {

            this.getList(false);
        });
    }

    onChangeSearchMethod = (option) => {
        this.setState({
            searchMethod: { ...this.state.searchMethod, selected: option.value },
        }, () => {
            this.getList();
        })
    }
    /****************************************************************/

    /*******************************PAGINATION***************************/
    /**
     * Change limit
     */
    onChangeLimit = (option) => {
        this.setState({ selectedLimit: option.value }, () => {
            this.getList();
        })
    }

    /**
     * Change page
     */
    onPageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, () => {
            this.getList(false);
        });
    }
    /****************************************************************/

    /*******************************CHECK AND ACTIONS***************************/
    checkAllItem = (event) => {
        const { checked } = event.target;

        this.selectedOrderIds = [];
        if (checked) {
            this.selectedOrderIds = _.map(this.state.credits, store => store.store_id);

            window.LadiUI.forEach(window.LadiUI.querySelector(".ladiui.checkbox"), function (e) {
                e.checked = true;
            });
        } else {
            window.LadiUI.forEach(window.LadiUI.querySelector(".ladiui.checkbox"), function (e) {
                e.checked = false;
            });
        }
    }

    checkItem = (event, orderId) => {
        const { checked } = event.target;
        const { selectedOrderIds } = this;

        if (checked) {
            if (!_.includes(selectedOrderIds, orderId)) {
                selectedOrderIds.push(orderId);
            }

            if (selectedOrderIds.length === this.state.credits.length) {
                document.getElementById("checkAllItem").checked = true;
            }
        } else {
            document.getElementById("checkAllItem").checked = false;
            _.remove(selectedOrderIds, selectedOrderId => selectedOrderId == orderId);
        }


    }


    sort = (event, sortKey) => {
        const { classList } = event.target;
        // Change arrow up and down
        if (_.includes(classList, 'up')) {
            this.setState({
                sortby: appConst.SORT_BY.DESCENDING
            });
            classList.remove('up');
        } else {
            this.setState({
                sortby: appConst.SORT_BY.ASCENDING
            });
            classList.add('up');
        }

        const data = this.state.credits;
        data.sort((a, b) => {

            if (this.state.sortby === 1) {
                return a[sortKey].toString().localeCompare(b[sortKey].toString());
            }
            return b[sortKey].toString().localeCompare(a[sortKey].toString());
        });
        this.setState({ credits: data });
    }


    /****************************************************************/


    render() {
        const { totalRecord } = this.props;
        const { activePage, selectedLimit, searchEmail, searchCode, fromDate, toDate, searchType, userInfo } = this.state;
        let fromItem = 0;
        let toItem = 0;
        if ((this.state.creditlogs || []).length > 0) {
            fromItem = (activePage - 1) * selectedLimit + 1;
            toItem = fromItem + this.state.creditlogs.length - 1;
        }


        const msgShowItem = `Show ${fromItem} to ${toItem} of ${baseHelper.formatNumber(totalRecord)} items`;
        const isLoadingData = this.props.loading && (this.props.waitting == types.LIST_CREDIT_LOGS);
        return (
            <div>
                <h1 className="page-title">Lịch sử cộng trừ credit</h1>
                {userInfo ?
                    <div>
                        <h1 className="page-title">Số dư hiện tại credit: {baseHelper.numberWithCommas(userInfo.credit_app.toFixed(2))}, Số dư hiện tại money: {baseHelper.numberWithCommas(userInfo.money.toFixed(2))}</h1>
                    </div>
                    :
                    <div>
                    </div>
                }
                <div>
                    <div className="ladiui-table-actions">
                        <div className="action-item">

                            <div className="ladiui search-keyword">
                                <input type="text" id="searchemail" placeholder="Tìm theo email" name="searchEmail" value={searchEmail} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.getList} />
                            </div>
                        </div>
                        {/* <div className="action-item">

                            <div className="ladiui search-keyword">
                                <input type="text" id="searchcode" placeholder="Tìm theo code" name="searchCode" value={searchCode} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.getList} />
                            </div>
                        </div> */}

                        <div className="action-item">
                            <div className="ladiui data-status">
                                <div className="ladiui-select-options">
                                    <span className="ladiui-select-init" style={{ minWidth: "170px" }}>{searchType.name}</span>
                                    <input type="hidden" name="select" defaultValue />
                                    <ul>
                                        {
                                            _.map(appConst.CREDIT_LOG_TYPE, option =>
                                                <li key={option.value} className="select-item" onClick={() => this.onChangeSearchType(option)}><a data-value={option.value}>{option.name}</a></li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="action-item">

                            <CustomDatePicker
                                customClass="ladiui input"
                                selected={fromDate}
                                onSelect={this.handleSelect} //when day is clicked
                                onChange={this.changeFromdate} //only when value has changed
                            />
                        </div>

                        <div className="action-item">
                            <CustomDatePicker
                                customClass="ladiui input"
                                selected={toDate}
                                onSelect={this.handleSelect} //when day is clicked
                                onChange={this.changeTodate} //only when value has changed
                            />
                        </div>
                    </div>
                    {
                        isLoadingData
                            ?
                            <LoadingTable />
                            :
                            <div>

                                <div className="ladi-card">

                                    <table className="ladiui table">
                                        <thead>
                                            <tr>
                                                {/* <th className="ladiui checkall text-center">
                                                    <input id="checkAllItem" onClick={this.checkAllItem} type="checkbox" className="ladiui checkbox ladiui-checkall" />
                                                </th> */}
                                                <th className="text-left">Email khách hàng</th>
                                                <th name="reference_no" onClick={e => this.sort(e, 'order_reference_no')} className="text-left sorting">Mã đơn hàng</th>

                                                <th name="amount" onClick={e => this.sort(e, 'amount')} className="text-left sorting">Amount</th>
                                                {/* <th className="text-left">Số tháng</th> */}
                                                <th className="text-left">Số dư trước</th>
                                                <th className="text-left">Số dư sau</th>
                                                <th className="text-left">Loại tài khoản</th>
                                                <th className="text-left">Ghi chú</th>
                                                <th name="created_at" onClick={e => this.sort(e, 'created_at')} className="text-left sorting">Thời gian tạo</th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                _.map(this.state.creditlogs, credit => {

                                                    return <tr key={credit._id}>
                                                        {/* <td className="text-center">
                                                            <input type="checkbox" onClick={(event) => this.checkItem(event, payment._id)} className="ladiui checkbox" />
                                                        </td> */}
                                                        <td>{credit.user_email}</td>
                                                        <td>{credit.reference_no}</td>

                                                        <td>{baseHelper.numberWithCommas(credit.credit.toFixed(2))}</td>
                                                        {/* <td>{credit.month}</td> */}
                                                        <td>{baseHelper.numberWithCommas(credit.before_balance.toFixed(2))}</td>
                                                        <td>{baseHelper.numberWithCommas(credit.after_balance.toFixed(2))}</td>
                                                        <td>{credit.type}</td>
                                                        <td>{credit.description}</td>
                                                        <td>{baseHelper.formatStrToDate(credit.created_at)}</td>

                                                        <td>


                                                        </td>
                                                    </tr>
                                                }
                                                )
                                            }
                                            {
                                                totalRecord <= 0 &&
                                                <tr className="text-center">
                                                    <td colSpan="100%">Không có bản ghi nào</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    }
                    {totalRecord > 0 &&
                        <div className="ladiui pagination-block">
                            <div className="ladiui search-actions">
                                <div className="ladiui form-filter">
                                    <div className="ladiui data-limit">
                                        <span>Show</span>
                                        <div className="ladiui per-page">
                                            <div className="ladiui-select-options">
                                                <span className="ladiui-select-init">{selectedLimit}</span>
                                                <input type="hidden" name="select" defaultValue />
                                                <ul>
                                                    {
                                                        _.map(appConst.PAGINATION.LIMIT_OPTIONS, option =>
                                                            <li key={option.value} className="select-item" onClick={() => this.onChangeLimit(option)}><a href="#" data-value={option.value}>{option.name}</a></li>
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ladiui showing">{msgShowItem}</div>
                                </div>
                            </div>
                            {
                                totalRecord > 0 && <div className="ladiui pagination">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={selectedLimit}
                                        totalItemsCount={totalRecord}
                                        pageRangeDisplayed={5}
                                        onChange={this.onPageChange}
                                        prevPageText={<i className="ladi-icon icon-left-arrow" />}
                                        nextPageText={<i className="ladi-icon icon-right-arrow" />}
                                        firstPageText={<i className="ladi-icon icon-double-arrow-left" />}
                                        lastPageText={<i className="ladi-icon icon-double-arrow-right" />}
                                    />
                                </div>
                            }

                        </div>
                    }
                </div>

            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        list: (data) => dispatch(partnerActions.listCreditLog(data))
    }
}

const mapStateToProps = (state) => ({ ...state.partner });

export default connect(mapStateToProps, mapDispatchToProps)(Credit);